import React from "react";

/**
 * Status badge with an optional live "pulse" dot (e.g. availability).
 */
export default function Badge({ children, pulse = false, className = "" }) {
  return (
    <span
      className={`inline-flex w-fit items-center gap-2 rounded-full border border-black/10 bg-black/5 px-3 py-1 text-xs font-medium text-neutral-700 dark:border-white/10 dark:bg-white/5 dark:text-neutral-300 ${className}`}
    >
      {pulse && (
        <span className="relative flex h-2 w-2 items-center justify-center">
          <span className="absolute h-full w-full animate-ping rounded-full bg-emerald-500/40" />
          <span className="relative h-1.5 w-1.5 rounded-full bg-emerald-400" />
        </span>
      )}
      {children}
    </span>
  );
}
